import { Component, computed } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { TranslocoModule } from '@ngneat/transloco';

import { DateRangePillComponent } from 'app/shared/components/date-range-pill/date-range-pill.component';
import { ExpiresAtPillComponent } from 'app/shared/components/expires-at-pill/expires-at-pill.component';
import { SummaryBriefComponent } from 'shared/components/summary-brief/summary-brief.component';

import { SummaryItemComponent } from '../../../../../../../shared/components/summary-item/summary-item.component';
import { BaseSummarySectionComponent } from '../../../../../../shared/base-classes/sections/base-summary-section.component';
import { SectionWrapperComponent } from '../../../../../../shared/components/containers/section-wrapper-container/section-wrapper-container.component';
import { GetTranslationKeyForValuePipe } from '../../../../../../shared/components/dropdowns/filter-multiselect-dropdown/get-translation-key-for-value.pipe';
import { ModuleSelectorComponent } from '../../../../../../shared/components/module-selector/module-selector.component';
import { GetIconFromOptionsPipe } from '../../../../../../shared/pipes/get-icon-from-options.pipe';
import { VehicleLinkCardComponent } from '../../../../vehicles/components/vehicle-link-card/vehicle-link-card.component';
import { VehicleRoadWorthyCheckRecordModel } from '../../../models/vehicle-road-worthy-check-record.model';
import { VEHICLE_ROAD_WORTHY_CHECK_RECORD_CATEGORIES } from '../../../translations/vehicle-road-worthy-checks-select-items';

@Component({
	selector: 'app-vehicle-road-worthy-checks-summary',
	templateUrl: 'vehicle-road-worthy-checks-summary.component.html',
	imports: [
		ReactiveFormsModule,
		SectionWrapperComponent,
		ExpiresAtPillComponent,
		VehicleLinkCardComponent,
		DateRangePillComponent,
		SummaryItemComponent,
		SummaryBriefComponent,
		GetIconFromOptionsPipe,
		GetTranslationKeyForValuePipe,
		TranslocoModule,
		ModuleSelectorComponent,
	],
})
export class VehicleRoadWorthyChecksSummaryComponent extends BaseSummarySectionComponent<VehicleRoadWorthyCheckRecordModel> {
	protected _skipCount: number = 0;
	recordCategories = VEHICLE_ROAD_WORTHY_CHECK_RECORD_CATEGORIES;

	constructor(private _formBuilder: FormBuilder) {
		super();
		this.detailsForm = this._formBuilder.group({
			tags: [null],
		});
	}

	isoDateFrom = computed(() =>
		new Date(this.recordData().startsAt).toISOString(),
	);
	isoDateTo = computed(() => new Date(this.recordData().endsAt).toISOString());

	protected _mapModelToForm(): void {
		const detailsFormData: any = {
			tags: this.recordData().tags,
		};
		this.detailsForm.setValue(detailsFormData);
	}

	protected _mapFormToModel(): Partial<VehicleRoadWorthyCheckRecordModel> {
		return {
			tags: this.detailsForm.value.tags,
		};
	}
}
